export default "__VITE_ASSET__c908640f__"